export const getPaymentBatchSummary = (payments = []) => {
    const totals = new Map();
    payments.forEach((payment) => {
        const currency = payment.amount?.currency || '';
        totals.set(currency, (totals.get(currency) || 0) + Number(payment.amount?.amount || 0));
    });
    const totalsByCurrency = Array.from(totals, ([currency, totalAmount]) => ({ currency, totalAmount }))
        .sort((a, b) => a.currency.localeCompare(b.currency));
    const isMultiCurrency = totalsByCurrency.length > 1;

    return {
        isMultiCurrency,
        currency: isMultiCurrency ? '[multiple]' : (totalsByCurrency[0]?.currency || ''),
        totalsByCurrency,
        // Amounts in different currencies cannot be combined without conversion.
        totalAmount: isMultiCurrency
            ? null
            : (totalsByCurrency[0]?.totalAmount ?? 0),
    };
};
